import React from 'react'

import Button from '../buttons/Button'
// import { Button, Icon } from '..'
import Icons from '../icons'
import ManagedList from './ManagedList'

type BasicDataProps = {
  title: string | number
  subtitle?: string
  icon?: string
  image?: string | undefined
  handleBack?: () => void
}
// type ActionProps = {
//   id: number
//   label: string
//   icon?: string
//   isOutlined?: boolean
// }
type DetailTileProps = {
  data: BasicDataProps
  onActionClick?: () => void
  onHandleExport?: () => void
  actionProps?: any
  showManagedList?: boolean
  groupData?: any
  groupValue?: any
  setGroupNameCode?: any
  permissions?: any
  checkPermission?: boolean
  onHandleImport?: () => void
}

const ListingHeader: React.FC<DetailTileProps> = ({
  data,
  onActionClick,
  actionProps,
  showManagedList = false,
  groupData = [],
  groupValue,
  setGroupNameCode,
  checkPermission,
  onHandleExport,
  onHandleImport,
}) => {
  return (
    <div className="px-5 py-3 flex justify-between flex-wrap gap-3 items-center bg-primaryExtraLight border-b border-formBorder">
      <div className="flex gap-6">
        <div className="flex items-center flex-wrap gap-5 ">
          <div className="flex items-center gap-3">
            {data?.handleBack && (
              <div className="cursor-pointer">
                <div className="bg-white rounded-md p-2 border border-formBorder">
                  <Icons
                    className={`size-3 2xl:size-4 block transition `}
                    name="chevron-left"
                    onClick={data?.handleBack}
                  />
                </div>
              </div>
            )}
            {data?.icon && (
              <div className="size-10 border border-formBorder flex bg-white items-center justify-center rounded-xl ">
                <Icons
                  className="text-blackAlt flex size-6 items-center justify-center"
                  name={data?.icon}
                />
              </div>
            )}
            {data?.image && (
              <div className="size-10 border border-formBorder bg-white rounded-xl  overflow-hidden">
                <img
                  src={data?.image}
                  alt="user"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div>
              <h4 className="font-bold text-l leading-6 text-blackAlt">
                {data.title}
              </h4>
              <h3
                dangerouslySetInnerHTML={{ __html: data.subtitle || '' }}
                className="text-common font-normal leading-5 text-grey-medium"
              ></h3>
            </div>
          </div>
        </div>
        {showManagedList && (
          <div className="flex items-center justify-start">
            <ManagedList
              groupData={groupData}
              selection={groupData?.findIndex(
                (item: any) => item.code === groupValue
              )}
              setGroupNameCode={setGroupNameCode}
            />
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <div>
          {/* {checkPermission?.('export') && (
            <>
              {!actionProps?.hideExport && (
                <Button
                  label="Export"
                  icon="upload"
                  outlined={true}
                  onClick={onHandleExport}
                />
              )}
            </>
          )} */}
          {actionProps?.actionCancel && (
            <Button
              label="Cancel"
              outlined={true}
              primary={false}
              onClick={() => actionProps.actionCancel()}
            />
          )}
        </div>
        {/* {checkPermission?.('add') && ( */}
        <>
          {onHandleImport && (
            <Button
              outlined
              label={'Import'}
              icon="import"
              disabled={actionProps?.disableSubmit}
            />
          )}

          {onHandleExport && (
            <Button
              outlined
              label={'Export'}
              icon="upload"
              disabled={actionProps?.disableSubmit}
              onClick={onHandleExport}
            />
          )}

          {onActionClick && checkPermission && (
            <div>
              <Button
                className="primaryButton"
                label={actionProps?.actionTitle ?? 'Add New'}
                icon={actionProps?.icon ?? ''}
                onClick={onActionClick}
                disabled={actionProps?.disableSubmit}
              />
            </div>
          )}
        </>
        {/* )} */}
      </div>
    </div>
  )
}

export default ListingHeader
